import React from 'react';

import qs from 'query-string';

import Footer from 'wanderu-component-footer';
import Helmet from 'wanderu-component-helmet';
import {
    localize,
} from 'wanderu-i18n';

import appConfig from '../../locales.config';
import BookSection from '../BookSection/BookSection';
import CompareSection from '../CompareSection/CompareSection';
import IntroMobileSection from '../IntroMobileSection/IntroMobileSection';
import SearchSection from '../SearchSection/SearchSection';
import TestimonialsSection from '../TestimonialsSection/TestimonialsSection';

import styles from './GetTheApp.scss';

function GetTheApp(props) {
    const {
        t,
        locale,
        location,
    } = props;

    const queries = qs.parse(location?.search) || {};

    return (
        <>
            <Helmet
                description={t('baseApp:page-description_get-the-app')}
                supportedLocales={appConfig.supportedLocales}
                title={t('baseApp:page-title_get-the-app')}
            />
            <IntroMobileSection
                campaign={queries?.utm_campaign || 'web-app_page_intro'}
                locale={locale}
                appPage
            />
            <SearchSection className={styles.section} />
            <CompareSection className={styles.section} />
            <BookSection className={styles.section} />
            <TestimonialsSection
                campaign={queries?.utm_campaign || 'web-app_page_testimonials'}
                className={styles.section}
            />

            <Footer />
        </>
    );
}

export { GetTheApp };
export default localize(GetTheApp, ['t']);
